import {createSlice} from "@reduxjs/toolkit";
import {ITemplate} from "../../../types/interfaces";

type TransactionState = {
    transactionsData: {
        transactions: Array<ITransaction>,
        currentPage: number,
        numberOfPages: number
    },

    filters: IFilters,
    templates: Array<ITemplate>,
    filtersTemplates: IFiltersTemplates,
    currentTransferCurrency: string,
    transferDataPreview: any,
    withdrawalCode: string | undefined
}

export interface IFiltersTemplates {
    accountNumber: string,
    recipient: string,
    templateName: string
}

export interface IFilters {
    hiddenAccountNumber?: string;
    accountNumber: string,
    period?: string | null,
    from?: string,
    to?: string,
    purpose?: string,
    recipient?: string,
    amount?: string,
    incoming?: boolean,
    outgoing?: boolean,
    other?: boolean,
    fees?: boolean,
    currency: string,
    selectedType?: string,
    templateName?: string,
    paymentRegion?: string,
    paymentType?: string,
}

export interface ITransaction {
    transactions: string;
    toAccountUserName?: string;
    deniedReason?: string | null;
    amount: number,
    balance: number,
    bankAddress: string | null,
    bankName?: string | null,
    beneficiaryAddress: string | null,
    beneficiaryCity: string | null,
    beneficiaryCountry: string | null,
    beneficiaryName: string | null,
    created: string,
    currency: string,
    direction: string,
    fromAccount: string,
    ibanCode: string | null,
    reference: string,
    recipient: string,
    swiftCode: string | null,
    toAccount: string,
    transactionNumber: string,
    transactionStatus: string,
    transactionType: string
    transactionSubType?: string
    recipientDetails : {
        beneficiarySortCode?: string | null;
        bankAddress: string
        bankName: string
        beneficiaryAddress: string
        beneficiaryCity: string
        beneficiaryCountry: string
        beneficiaryName: string
        ibanCode: string
        swiftCode: string
        beneficiaryAccountNumber?: string | null
    }
}

const initialState: TransactionState = {
    transactionsData: {
        transactions: [],
        numberOfPages: 0,
        currentPage: 1
    },
    filters: {
        accountNumber: '',
        period: null,
        from: '',
        to: '',
        purpose: '',
        recipient: '',
        amount: '',
        incoming: false,
        outgoing: false,
        currency: '',
        selectedType: '',
        templateName: '',
        paymentRegion: ''
    },
    filtersTemplates: {
        accountNumber: '',
        recipient: '',
        templateName: ''
    },
    templates: [],
    currentTransferCurrency: '',
    transferDataPreview: {},
    withdrawalCode: undefined
}

export const transactionsSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {
        setTransactionsData(state, action) {
            state.transactionsData = action.payload
        },
        // setTransactionPage(state, action) {
        //     state.
        // },
        setFilters(state, action) {
            state.filters = action.payload
        },
        setPaymentRegionFilter(state, action) {
            state.filters.paymentRegion = action.payload
        },
        setTransactionTypeFilter(state, action) {
            state.filters.selectedType = action.payload
        },
        setFiltersTemplates(state, action) {
            state.filtersTemplates = action.payload
        },
        setTemplateList(state, action) {
            state.templates = action.payload
        },
        setCurrentTransferCurrency(state, action) {
            state.currentTransferCurrency = action.payload
        },
        clearTransactionSlice(state) {
            state.transactionsData.transactions = []
            state.filters = {
                accountNumber: '',
                period: null,
                from: '',
                to: '',
                purpose: '',
                recipient: '',
                amount: '',
                incoming: false,
                outgoing: false,
                currency: '',
                paymentRegion: '',
            }
            state.filtersTemplates = {
                accountNumber: '',
                recipient: '',
                templateName: ''
            }
            state.templates = []
        },
        setTransferDataPreview(state, action) {
            state.transferDataPreview = action.payload
        },
        setWithdrawalCode (state, action) {
            state.withdrawalCode = action.payload
        }
    },
})
export const {
    setTransactionsData,
    setFilters,
    setTemplateList,
    setFiltersTemplates,
    setPaymentRegionFilter,
    setTransactionTypeFilter,
    setTransferDataPreview,
    setWithdrawalCode
} = transactionsSlice.actions;

export default transactionsSlice.reducer
